import * as actionTypes from "../../../actions/actionTypes";

const personalInfo = (
  state = {
    specialitiesOptions: [],
    languagesOptions: [],
    educationalOptions: [],
    dataChanged: false,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_PERSONAL_INFO: {
      return { ...state, dataChanged: true, ...action.payload };
    }
    default:
      return state;
  }
};

export default personalInfo;
